import { Select as SelectView, SelectTrigger, SelectContent, SelectItem, SelectValue } from "@/shared/ui/select";
import { cn } from "@/shared/lib/utils";

interface IOption {
    value: string;
    label: string;
    image?: string;
}

interface ViewSelectProps {
    value: string;
    onChange: (value: string) => void;
    data: IOption[];
    placeholder?: string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
    error?: boolean;
    errorMessage?: string;
    disabled?: boolean;
}

export const Select: React.FC<ViewSelectProps> = ({ 
    value, 
    onChange, 
    data, 
    placeholder = "Selecione uma opção", 
    className = "", 
    size = "md",
    error = false,
    errorMessage,
    disabled = false
}) => {
    return (
        <div className="space-y-1">
            <SelectView
                value={value || undefined}
                onValueChange={(val) => onChange(val)}
                disabled={disabled}
            >
                <SelectTrigger className={cn(
                    "min-w-[200px] w-auto bg-neutral-800 border-white/10 text-white",
                    disabled && "opacity-60 cursor-not-allowed pointer-events-none",
                    error && "border-red-500",
                    className
                )} disabled={disabled}>
                    <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent className="bg-neutral-800 border-white/10 text-white">
                    {data.map((item) => (
                        <SelectItem key={item.value} value={item.value}>
                            <div className={cn("flex items-center gap-2", size === "sm" ? "text-xs" : size === "lg" ? "text-lg" : "")}>
                                {item.image && <img src={item.image} alt={item.label} className={cn("w-5 h-5 rounded-full", size === "sm" ? "w-4 h-4" : size === "lg" ? "w-6 h-6" : "")} />}  {item.label}
                            </div>
                        </SelectItem>
                    ))}
                </SelectContent>
            </SelectView>
            {error && errorMessage && (
                <p className="text-red-500 text-sm">{errorMessage}</p>
            )}
        </div>
    );
};
